export function quantityLimitation(quantity: number): string {
  if (typeof quantity === 'number') {
    return quantity > 40 ? 'более 40' : quantity.toString();
  } else {
    return '';
  }
}
